import { createObservability } from '../createObservability';
import type { IObservability } from '../createObservability';
import { ConsoleAnalyticsProvider } from './ConsoleAnalyticsProvider';
import { ConsoleErrorProvider } from './ConsoleErrorProvider';
import { ConsoleLoggerProvider } from './ConsoleLoggerProvider';
import { ConsoleMetricsProvider } from './ConsoleMetricsProvider';
import { ConsoleTracingProvider } from './ConsoleTracingProvider';

/** Composition root padrão desta fase (console-only). */
export function createConsoleObservability(): IObservability {
  return createObservability({
    metrics: new ConsoleMetricsProvider(),
    logger: new ConsoleLoggerProvider(),
    errors: new ConsoleErrorProvider(),
    tracing: new ConsoleTracingProvider(),
    analytics: new ConsoleAnalyticsProvider(),
  });
}
